export function assertNever(value: never) {
  throw new Error(`Value isn't of type 'never': "${value}"`);
}
